import InnerComponent from '@Components/Sales/PackingSlip/PackingSlipForm';
import orgContainer from '@Components/AppContainer';

const UpdatePackingSlip = () => ((orgContainer(InnerComponent)));
export default UpdatePackingSlip;